"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Field = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

const selectColor = (theme, disabled) => {
  if (disabled) {
    return theme.colorNeutral15;
  }

  return theme.colorNeutral90;
};

const field = ({
  theme,
  disabled
}) => (0, _stylitas.css)`
  width: 100%;
  border: none;
  outline: none;
  color: ${selectColor(theme, disabled)};
  ${_styleUtilities.typography['4xl'](theme)};
  ::placeholder {
    color: ${theme.colorNeutral15};
  }
  caret-color: ${theme.colorBrandPrimaryLight};
  background: transparent;

  ${_styleUtilities.media.md`
    ${_styleUtilities.typography['6xl'](theme)};
  `}
`;

const Field = _stylitas.styled.input`
  ${field};
`;
exports.Field = Field;